import React, { createContext, useCallback, useContext, useMemo, type ReactNode } from 'react'
import { useMutation } from '@tanstack/react-query'
import type { Playlist } from '../../api/rootstech/playlist/playlist.types'
import { createPlaylist as createPlaylistApi } from '../../api'

type CreatePlaylist = (params: { name: string; description: string }) => Promise<Playlist>

// type UpdatePlaylist = (
//   id: string,
//   payload: { name: string; description: string; itemsToAdd: string[]; itemsToRemove: string[] }
// ) => Playlist

// type GetPlaylistIdsForItems = (ids: string[]) => PlaylistsByItem

type PlaylistsGlobalContextState = {
  isPending: boolean
  error: unknown
  playlists: Playlist[]
  createPlaylist?: CreatePlaylist
  // updatePlaylist: UpdatePlaylist
  // getPlaylistIdsForItems: GetPlaylistIdsForItems
}

const initialState: PlaylistsGlobalContextState = {
  isPending: false,
  error: null,
  playlists: [],
}

const PlaylistsGlobalContext = createContext(initialState)

export const usePlaylistsGlobalContext = (): PlaylistsGlobalContextState => useContext(PlaylistsGlobalContext)

export const PlaylistsGlobalProvider = ({ children }: { children: ReactNode }): JSX.Element => {
  const {
    mutateAsync: createPlaylistMutation,
    isPending,
    error,
  } = useMutation({
    mutationFn: createPlaylistApi,
    onSuccess: () => {
      console.log('success')
    },
  })

  const createPlaylist: CreatePlaylist = useCallback(
    async (params) => {
      const { data } = await createPlaylistMutation({ data: params })
      return data
    },
    [createPlaylistMutation]
  )

  const value: PlaylistsGlobalContextState = useMemo(
    () => ({
      playlists: [], // TODO: integrate query for fetching playlists
      createPlaylist,
      isPending,
      error,
    }),
    [createPlaylist, error, isPending]
  )

  return <PlaylistsGlobalContext.Provider value={value}>{children}</PlaylistsGlobalContext.Provider>
}
